
import clienteAxios from './Axios';

const tokenAuth = token => {
    if(token) {
        clienteAxios.defaults.headers.common['access-token'] = token;
    } else {
        delete clienteAxios.defaults.headers.common['access-token'];
    }
}

export default tokenAuth;